import { RawTagData, type StoryblokEditable } from '@activebrands/core-web/libs/storyblok/storyblok';
import transformPreviewEditable from '@activebrands/core-web/libs/storyblok/utils/transform-preview-editable';

export type TagType = {
    component: 'tag';
    id: string;
    sbEditable?: StoryblokEditable;
    text: string;
};

type TagProp = RawTagData | RawTagData[] | undefined;

type TransformTagProps = {
    tag: TagProp;
};

const transformTag = ({ tag }: TransformTagProps): TagType | undefined => {
    if (!tag || (Array.isArray(tag) && !tag?.[0])) {
        return;
    }

    const tagData = Array.isArray(tag) ? tag[0] : tag;
    const { _uid, _editable, component, tag: text } = tagData;

    return {
        component,
        id: _uid,
        sbEditable: transformPreviewEditable(_editable),
        text,
    };
};

export default transformTag;
